export const getIsGoingToReadExist = state => false;

export const getUserBooks = state => state.book.books;

export const getBookError = state => state.book.error;

